<app-nav></app-nav>
<section class="homeNew">
  <div class="container">
    <div class="col homeNew-col">
      <div class="content-box">
        <h4>Buy</h4>
        <div class="row">
          <div class="col-3 no-padding" routerLink="/family-health-insurance" (click)="createProspectForFHI()">
            <div class="product-icon">
              <span class="icon icon-fhi"></span>
            </div>
            <div><label class="product-title">Health Insurance</label></div>
          </div>
          <div class="col-3 no-padding" routerLink="/motor-insurance" (click)="createProspectForMotor()">
            <div class="product-icon">
              <span class="icon icon-motor"></span>
            </div>
            <div><label class="product-title">Motor Insurance</label></div>
          </div>
          <div class="col-3" routerLink="/personal-accident" (click)="createProspectForPA()">
            <span class="special"><img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/special-icon.svg">
              SPECIAL</span>
            <div class="product-icon">
              <span class="icon icon-pa"></span>
            </div>
            <div><label class="product-title">Personal Accident</label></div>
          </div>
          <div class="col-3 no-padding" routerLink="/doctor-professional-indemnity" (click)="createProspectForPI()">
            <div class="product-icon">
              <span class="icon icon-dpi"></span>
            </div>
            <div><label class="product-title">Doctors' Indemnity</label></div>
          </div>
        </div>
        <div class="row">
          <div class="col-3 productCard" routerLink="/covid-protection" (click)="createProspectForCovid()">
            <span class="new-product">NEW!</span>
            <div class="product-icon">
              <span class="icon icon-covid"></span>
            </div>
            <div><label class="product-title">Corona Kavach Insurance</label></div>
          </div>
          <div class="col-3 productCard" (click)="healthAssureUpdate()">
            <span class="new-product">
              NEW!</span>
            <div class="product-icon">
              <span class="icon icon-opd"></span>
            </div>
            <div><label class="product-title">Health Services</label></div>
            <div class="subtitle"><label class="product-subTitle">by HealthAssure</label></div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <h4>View</h4>
        <div class="row">
          <div class="col-3">
            <div class="product-icon" routerLink="/yourPolicies">
              <span class="icon icon-policy"></span>
            </div>
            <div><label class="product-title">Your Policies</label></div>
          </div>
          <div class="col-3">
            <div class="product-icon" routerLink="/e-cards">
              <span class="icon icon-card"></span>
            </div>
            <div><label class="product-title">E-Cards</label></div>
          </div>
          <div class="col-3">
            <div class="product-icon" routerLink="/hospitalLocator">
              <span class="icon icon-hospital"></span>
            </div>
            <div><label class="product-title">Hospital Locator</label></div>
          </div>
          <div class="col-3">
            <div class="product-icon" routerLink="/add-policy">
              <span class="icon icon-add-policy"></span>
            </div>
            <div><label class="product-title">Add Policy</label></div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <h4>Claim</h4>
        <div class="row">
          <div class="col-3">
            <div class="product-icon" routerLink="/register">
              <span class="icon icon-intimate"></span>
            </div>
            <div><label class="product-title">Register</label></div>
          </div>
          <div class="col-3">
            <div class="product-icon" routerLink="/submit">
              <span class="icon icon-submit"></span>
            </div>
            <div><label class="product-title">Submit</label></div>
          </div>
          <div class="col-3">
            <div class="product-icon" routerLink="/status">
              <span class="icon icon-status"></span>
            </div>
            <div><label class="product-title">Check Status</label></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <app-click-to-call></app-click-to-call> -->
    <div class="fixed-footer col">
      <div class="row footer-body">
        <div class="col text-center p-0" routerLink="/home"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Home-fill.svg"
            class="img img-fluid" alt=""></div>
        <div class="col text-center p-0"><a href="tel:+919696683999"><img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone-bordered.svg"
              class="img img-fluid" alt=""></a></div>
        <div class="col text-center p-0" routerLink="/email"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/email-bordered.svg"
            class="img img-fluid" alt=""></div>
        <div class="col text-center p-0" routerLink="/profile"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Profile-bordered.svg"
            class="img img-fluid" alt=""></div>
        <div class="col text-center p-0" routerLink="/notifications-new"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/alarm-bordered.svg"
            class="img img-fluid" alt=""><span class="pending-notifications" *ngIf="notificationCount"></span></div>
      </div>
    </div>
  </div>
  
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>

<div class="modal fade" id="claimsModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body claim-pop text-center">
        <div class="claim-icon-sorry">!</div>
        <h6>Sorry</h6>
        <p>You have not registered a claim yet. Please lodge a claim first.</p>
        <div class="text-center">
          <button type="button" class="btn btn-blue" data-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>